import React, { useState, useCallback } from "react";
import { Container, Row, Card, CardHeader, Button } from "reactstrap";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import VehicleModal from "./Modals/VehicleModal";
import VehiclesTable from "./VehiclesTable";

const Vehicles = () => {
    document.title = "Pregled vozila";
    
    const [modal, setModal] = useState(false);
    const toggleModal = useCallback(() => setModal(!modal), [modal]);

    return (
        <div className="page-content">
            <ToastContainer closeButton={false} limit={2} />
            <VehicleModal isEdit={false} show={modal} onCloseClick={() => toggleModal()} />
            <Container fluid>
                <Card className="overflow-hidden">
                    <CardHeader className="border-0">
                        <Row className="align-items-center gy-3">
                            <div className="col-sm">
                                <h5 className="card-title mb-0 text-uppercase">Pregled vozila</h5>
                            </div>
                            <div className="col-sm-auto">
                                <div className="d-flex gap-1 flex-wrap">
                                    <Button color="success" id="add-part-btn" outline onClick={() => {toggleModal()}}>
                                        <i className="ri-add-line align-bottom me-1"/> Dodaj vozilo
                                    </Button>
                                </div>
                            </div>
                        </Row>
                    </CardHeader>
                    <VehiclesTable />
                </Card>                
            </Container>
        </div>
    );
};

export default Vehicles;